export const placeholderShapesArrayStart = [
    {
        id: 1,
        shape: 'Hexagon',
        shapeDropped: false,
    },
    {
        id: 2,
        shape: 'Blob',
        shapeDropped: false
    },
    {
        id: 3,
        shape: "Triangle",
        shapeDropped: false
    },
    {
        id: 4,
        shape: "Sun",
        shapeDropped: false
    },
    {
        id: 5,
        shape: "Shield",
        shapeDropped: false
    },
    {
        id: 6,
        shape: "Circle",
        shapeDropped: false
    },
    {
        id: 7,
        shape: "Plus",
        shapeDropped: false
    },
    {
        id: 8,
        shape: "Heart",
        shapeDropped: false
    },
    {
        id: 9,
        shape: "Star",
        shapeDropped: false
    },
    {
        id: 10,
        shape: "Rectangle",
        shapeDropped: false
    },
    {
        id: 11,
        shape: "Label",
        shapeDropped: false
    },
    {
        id: 12,
        shape: "Water",
        shapeDropped: false
    }
]

export const draggableShapesArrayStart = [
    {
        id: 1,
        shape: 'Hexagon',
        shapeMoved: false,
    },
    {
        id: 2,
        shape: 'Blob',
        shapeMoved: false
    },
    {
        id: 3,
        shape: "Triangle",
        shapeMoved: false
    },
    {
        id: 4,
        shape: "Sun",
        shapeMoved: false
    },
    {
        id: 5,
        shape: "Shield",
        shapeMoved: false
    },
    {
        id: 6,
        shape: "Circle",
        shapeMoved: false
    },
    {
        id: 7,
        shape: "Plus",
        shapeMoved: false
    },
    {
        id: 8,
        shape: "Heart",
        shapeMoved: false
    },
    {
        id: 9,
        shape: "Star",
        shapeMoved: false
    },
    {
        id: 10,
        shape: "Rectangle",
        shapeMoved: false
    },
    {
        id: 11,
        shape: "Label",
        shapeMoved: false
    },
    {
        id: 12,
        shape: "Water",
        shapeMoved: false
    }
]